import React, { useContext, useEffect, useState } from 'react';
import { Route, Link, useRouteMatch } from 'react-router-dom';
import classNames from 'classnames';
import UsersProvider from '../../providers/Users/usersProvider';
import ConfigableTable from '../ConfigableTable/configableTable';
import TabbedPage from '../TabbedPage/tabbedPage';
import UserCard from '../UserCard/userCard';
import MainInfo from '../UserCard/mainInfo';
import UserViewModel from '../../viewModels/UserViewModel';
import BanUser from '../UserCard/banUser';

const Popover = () => {
  const match = useRouteMatch();
  const id = match.params.id;
  const users = useContext(UsersProvider.context) as any;
  useEffect(() => users.actions.voidGetById(id), [id]);
  const model = users.state.cached[id];
  if (!model) return null;
  return <UserCard type="purple" title={model.name} image={model.photo}>
    {model.reported && !model.banned && <div className="report-reason">Reported for {model.reportedReason}</div>}
    {model.banned && <div className="report-reason">Banned until {model.bannedUntilAsString}</div>}
    <br />
    <MainInfo user={model} />
    <BanUser user={model} />
  </UserCard>;
};

const Actions = ({ data }: { data: UserViewModel }) => {
  const match = useRouteMatch();
  return <Link to={`${match.path}/actions/${data.id}`}>
    <button className="std-button">View</button>
  </Link>;
};

const columns = {
  Name: 'name',
  Email: 'email',
  Location: 'location',
  Created: 'createdAsString',
  key: 'id',
  Actions: Actions
};

const visibleColumns = [
  'Name', 'Email', 'Location', 'Created', 'Actions'
];


export default () => {
  const [search, setSearch] = useState<string | null>(null);
  const users = useContext(UsersProvider.context) as any;
  useEffect(() => users.actions.voidSearchUsers(search), [search]);
  const match = useRouteMatch();
  return (
    <div>
      <div className="dashboard main-pane">
        <input className="search"
               placeholder="🕵️  Search visitors"
               onChange={e => setSearch(e.target.value)} />
        <ConfigableTable
          columns={columns}
          visibleColumns={visibleColumns}
          rows={users.state.rows}
        />
      </div>
      <Route path={`${match.path}/actions/:id`} component={Popover} />
    </div>
  );
}
